export const ERROR_SEVERITY = {
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH",
  CRITICAL: "CRITICAL",
} as const;

export const ERROR_METHOD = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  PATCH: "PATCH",
  DELETE: "DELETE",
} as const;

export const ERROR_LOG_STATUS = {
  OPEN: "open",
  ASSIGNED: "assigned",
  RESOLVED: "resolved",
} as const;

export const ERROR_LOG_STATUS_LABEL: Record<string, string> = {
  [ERROR_LOG_STATUS.OPEN]: "Open",
  [ERROR_LOG_STATUS.ASSIGNED]: "Assigned",
  [ERROR_LOG_STATUS.RESOLVED]: "Resolved",
};

export const ERROR_LOG_STATUS_BADGE: Record<string, string> = {
  [ERROR_LOG_STATUS.OPEN]: "light-danger",
  [ERROR_LOG_STATUS.ASSIGNED]: "light-warning",
  [ERROR_LOG_STATUS.RESOLVED]: "light-success",
};

export const ERROR_LOG_STATUS_OPTIONS = [
  { value: "", label: "All Status" },
  { value: ERROR_LOG_STATUS.OPEN, label: ERROR_LOG_STATUS_LABEL.open },
  { value: ERROR_LOG_STATUS.ASSIGNED, label: ERROR_LOG_STATUS_LABEL.assigned },
  { value: ERROR_LOG_STATUS.RESOLVED, label: ERROR_LOG_STATUS_LABEL.resolved },
];

export const ERROR_METHOD_OPTIONS = [
  { value: "", label: "All Methods" },
  { value: ERROR_METHOD.GET, label: "GET" },
  { value: ERROR_METHOD.POST, label: "POST" },
  { value: ERROR_METHOD.PUT, label: "PUT" },
  { value: ERROR_METHOD.PATCH, label: "PATCH" },
  { value: ERROR_METHOD.DELETE, label: "DELETE" },
];

export const ERROR_SEVERITY_OPTIONS = [
  { value: "", label: "All Severities" },
  { value: ERROR_SEVERITY.LOW, label: "Low" },
  { value: ERROR_SEVERITY.MEDIUM, label: "Medium" },
  { value: ERROR_SEVERITY.HIGH, label: "High" },
  { value: ERROR_SEVERITY.CRITICAL, label: "Critical" },
];

export const getErrorSeverityBadgeColor = (severity?: string | null) => {
  const key = severity?.toLowerCase();
  if (key === ERROR_SEVERITY.CRITICAL.toLowerCase() || key === "high") {
    return "light-danger";
  }
  if (key === ERROR_SEVERITY.MEDIUM.toLowerCase() || key === "warning") {
    return "light-warning";
  }
  if (key === ERROR_SEVERITY.LOW.toLowerCase() || key === "info") {
    return "light-info";
  }
  return "light-secondary";
};

export const formatErrorLogStatus = (status?: string | null) =>
  ERROR_LOG_STATUS_LABEL[status ?? ""] ?? "N/A";

export const getErrorLogStatusBadgeColor = (status?: string | null) =>
  ERROR_LOG_STATUS_BADGE[status ?? ""] ?? "light-secondary";

export const isOpenErrorLogFilter = (value: string) =>
  value === ERROR_LOG_STATUS.OPEN;

export const isErrorLogResolved = (status?: string | null) =>
  status === ERROR_LOG_STATUS.RESOLVED;
